import App from './container/app'

window.$ = jQuery
window.jQuery = jQuery

var app = App()
app.init()



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/index.js